<template>
  <div>
    <p class="headerstyle">กรุณากรอกข้อมูลผู้สอน</p>
    <div id="fadeIn" v-if="errors.length">
      <b>กรุณากรอกข้อมูลให้ถูกต้อง :</b>
      <ul>
        <li v-for="error in errors" :key="error">{{ error }}</li>
      </ul>
    </div>
    <div class="fromstyle">
      <form @submit.prevent="checkForm">
        <div class="flex justify-center h-full">
          <Profile @Get-imgUrl="GetimgUrl" class="Profile-style" />
        </div>

        <br />
        <p v-show="!imgUrl" class="headerstyle">ใส่รูปผู้สอน</p>
        <vs-input
          class="w-full"
          id="FirstName"
          placeholder="ชื่อ"
          type="text"
          v-model="FirstName"
          name="FirstName"
          required
        />
        <br />
        <vs-input
          class="w-full"
          id="LastName"
          placeholder="นามสกุล"
          type="text"
          v-model="LastName"
          name="LastName"
          required
        />
        <br />
        <vs-input
          class="w-full"
          id="email"
          placeholder="อีเมล"
          type="email"
          v-model="email"
          name="email"
          required
        />
        <br />
        <vs-input
          class="w-full"
          id="phone"
          placeholder="เบอร์ติดต่อ"
          type="number"
          v-model="phone"
          name="phone"
          required
        />
        <br />
        <vs-textarea label="รายละเอียด" height="100%" v-model="description" />
        <vs-row vs-w="12">
          <vs-col vs-w="12" class="flex justify-center">
            <button type="submit" value="Submit" class="share-btn">
              เพิ่มผู้สอน
            </button>
          </vs-col>
        </vs-row>
      </form>
    </div>
  </div>
</template>

<script>
import Profile from "@/views/elements/Profiletemplete.vue";
import axios from "../../../util/backend";
import baseUrl from "../../../util/baseUrl";

export default {
  components: {
    Profile
  },
  data() {
    return {
      FirstName: null,
      LastName: null,
      email: null,
      phone: null,
      description: null,
      imgUrl: null,
      errors: []
    };
  },
  methods: {
    async checkForm(e) {
      this.errors = [];
      if (this.FirstName && this.LastName && this.email && this.imgUrl) {
        this.$vs.loading();
        let config = {
          method: "post",
          url: `${baseUrl.baseurl()}/createLecturer`,
          data: {
            first_name: this.FirstName.trimLeft(),
            last_name: this.LastName.trimLeft(),
            detail: this.description,
            email: this.email,
            phone: this.phone,
            img_url: this.imgUrl
          }
        };
        try {
          let response = await axios.api(config);
          if (response.data.status === "success") {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "การสร้างผู้สอน",
              text: "สำเร็จ",
              color: "success",
              icon: "check_box",
              position: "top-right"
            });
            this.$router.push({ path: "/lecturer" });
          }
        } catch (error) {
          //console.log("error",error.response.data.error);
          this.$vs.notify({
            title: "Error message",
            text: `${
              error.response.data.error ? error.response.data.error : error
            }`,
            color: "danger",
            icon: "error",
            position: "top-right"
          });
          this.$vs.loading.close();
        }
      }

      if (!this.imgUrl) {
        this.errors.push("กรุณาใส่รูปผู้สอน");
        this.$vs.notify({
          title: "Error",
          text: "กรุณาใส่รูปผู้สอน",
          color: "danger",
          icon: "check_box",
          position: "top-right"
        });
      }
    },
    GetimgUrl(e) {
      this.imgUrl = e;
    }
  }
};
</script>

<style lang="scss" scoped>
.headerstyle {
  color: #1a3683;
  font-size: 1.125rem;
  line-height: 1.75rem;
  font-weight: 600;
  text-align: center;
}

.share-btn {
  background-color: #0430ad;
  padding: 10px 20px 10px 20px;
  border-radius: 10px;
  border-style: none;
  color: #ffff;

  &:hover {
    transition-delay: 100ms;
    background-color: #072c49;
  }
  &:active {
    background-color: #072c49;
  }
}
.Profile-style {
  height: 10rem;
  width: 10rem;
}
</style>
